/*eslint-disable */
import root from '@/_helpers/roots';
import axios from 'axios';
import Vue from 'vue'
let globalNotificationApiUrl = root.globalNotificationApiUrl.link;
let globalNotificationListApiUrl = root.globalNotificationListApiUrl.link;
let allNotificationReadListApiUrl = root.allNotificationReadListApiUrl.link;

export default {
  state: {
    getNotificationState:{},
    getGlobalNotificationState:{}
  },
  mutations: {
    getNotificationMutation(state, value) {
      Vue.set(state, 'getNotificationState', value);
    },
    getGlobalNotificationMutation(state, value) {
      Vue.set(state, 'getGlobalNotificationState', value);
    },
  },
  actions: {
    // Patch Global Notification Read List Function
    patchGlobalNotificationReadMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch(allNotificationReadListApiUrl)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    readNotificationByIdAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch(globalNotificationListApiUrl, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    // get Global Notification List Function
    getGlobalNotificationMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(globalNotificationListApiUrl + '?is_read=' + payload.flag)
          .then((response) => {
            context.commit('getGlobalNotificationMutation', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    // get Notification Fun
    getNotificationFunc(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(globalNotificationApiUrl)
          .then((response) => {
            context.commit('getNotificationMutation', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    // Post Notification Fun
    postNotificationFunc(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(globalNotificationApiUrl, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    }
  },
  getters: {
    getNotificationGetters : state => state.getNotificationState,
    getGlobalNotificationGetters : state => state.getGlobalNotificationState
  }
}